<div mat-dialog-title style="margin:0px;">{{header}}</div> 

    
    <mat-dialog-content>

        <div style="padding: 10px;" *ngIf = "!isDistributebyEmail">
                Are you sure you want to send this report to the emails listed?
                <br />
                If you continue, the report will be sent to the recipient(s) once the report is processed.
        </div>

        <div style="padding: 10px;" *ngIf = "isDistributebyEmail">
            Are you sure you want to distribute this report to the emails of the student/contact(s) listed?
            <br />{{selectedRecipients}}<br /><br />
            If you continue, this report will be emailed to ALL students/contacts selected.  You will receive an email with the results.
            <br />
        </div>
            

    </mat-dialog-content>
    
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button id="okReporttToEmailButton" image="next arrow.png" label="Continue" (clickEvent)="okClick()"></tyl-button>
            <tyl-button id="cancelReporttToEmailButton" image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
        </div>
    </mat-dialog-actions>